module.exports = __webpack_public_path__ + "static/media/power.436fbb4c.svg";